import React from 'react';
import styles from './MenuFilter.module.scss';
import FilterMenuSection from '../FilterMenuSection/FilterMenuSection';
import RoundedButton from '../../../../../../../components/RoundedButton/RoundedButton';
import cn from 'classnames';
import { stageLifeCycleList, warrantyList, enumFilter } from '../../constanst';

const MenuFilter = ({
  selectedStage,
  selectedWarranty,
  stageFilter,
  warFilter,
  onMenuClick,
  onConfirm,
  onReset,
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.body}>
        <FilterMenuSection
          label="Стадии помещения при создании заявки:"
          fieldValue={enumFilter.STAGE}
          onMenuClick={onMenuClick}
          selectedKeys={selectedStage}
          options={stageLifeCycleList}
          selectedValuesFilter={stageFilter}
        />

        <FilterMenuSection
          label="Гарантия:"
          fieldValue={enumFilter.WARRANTY}
          onMenuClick={onMenuClick}
          selectedKeys={selectedWarranty}
          options={warrantyList}
          selectedValuesFilter={warFilter}
        />
      </div>
      <div className={styles.footer}>
        <RoundedButton
          onClick={onConfirm}
          text="Применить"
          className={cn(styles.customBtn, styles.confirmBtn)}
        />
        <RoundedButton
          onClick={onReset}
          text="Сбросить"
          className={cn(styles.customBtn, styles.resetBtn)}
        />
      </div>
    </div>
  );
};

export default MenuFilter;
